export default __webpack_public_path__ + "static/media/gp-icon.8a29cd5b.svg";